var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66667 16.6667H3.33333M3.33333 16.6667H7.5M3.33333 16.6667V6.00016C3.33333 5.06674 3.33333 4.59968 3.51499 4.24316C3.67478 3.92956 3.92956 3.67478 4.24316 3.51499C4.59968 3.33333 5.06674 3.33333 6.00016 3.33333H7.3335C8.26692 3.33333 8.73298 3.33333 9.0895 3.51499C9.4031 3.67478 9.65873 3.92956 9.81852 4.24316C10 4.59933 10 5.06583 10 5.99742V8.3335M7.5 16.6667H16.6667M7.5 16.6667V11.9735C7.5 11.5357 7.5 11.3167 7.5525 11.1125C7.59903 10.9315 7.67561 10.7599 7.77913 10.6043C7.89588 10.4289 8.05927 10.282 8.3846 9.98975L10.3026 8.26664C10.9315 7.7016 11.2462 7.41887 11.6021 7.3116C11.9158 7.21704 12.2506 7.21704 12.5643 7.3116C12.9204 7.41895 13.2356 7.70183 13.8656 8.26782L15.7822 9.98975C16.1079 10.2823 16.2704 10.4288 16.3872 10.6043C16.4908 10.7599 16.5672 10.9315 16.6138 11.1125C16.6663 11.3167 16.6667 11.5357 16.6667 11.9735V16.6667M16.6667 16.6667H18.3333",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSchool);
export default __webpack_public_path__ + "static/media/nav-school.ce6a676a20b253d8e1738b40be81f735.svg";
export { ForwardRef as ReactComponent };